
        var result = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./nbinput-date.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    